import { motion, useReducedMotion } from "framer-motion";

const BRANDS = {
  apple: { src: "/brands/apple.svg", glow: "rgba(244,244,239,0.55)", label: "Apple logo" },
  samsung: { src: "/brands/samsung.svg", glow: "rgba(61,111,224,0.6)", label: "Samsung logo" },
  google: { src: "/brands/google.svg", glow: "rgba(234,67,53,0.5)", label: "Google logo" },
};

export const BrandMark = ({ brand, size = 42, dur = 7, delay = 0, className = "", interactive = true }) => {
  const b = BRANDS[brand];
  const reduce = useReducedMotion();
  if (!b) return null;
  return (
    <motion.img
      src={b.src}
      alt={b.label}
      draggable="false"
      className={`select-none ${interactive ? "cursor-pointer" : "pointer-events-none"} ${className}`}
      style={{ width: size, height: size, objectFit: "contain", filter: `drop-shadow(0 0 18px ${b.glow})` }}
      animate={reduce ? {} : { y: [0, -12, 0], rotate: [-5, 5, -5] }}
      transition={{ duration: dur, delay, repeat: Infinity, ease: "easeInOut" }}
      whileHover={interactive && !reduce ? { scale: 1.3, rotate: 10, transition: { type: "spring", stiffness: 300, damping: 12 } } : undefined}
      whileTap={interactive ? { scale: 0.9 } : undefined}
    />
  );
};
